import React from 'react'
import PropTypes from 'prop-types'

import { Player } from 'video-react'

import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'

import ExternalLink from '@material-ui/icons/Launch'
import { OutboundLink } from 'gatsby-plugin-google-analytics'

require('./../../../../assets/styles/video.css')

const styles = {
  cardstyle: {
    padding: 5,
  },
  figcaption: {
    padding: 5
  },
  icon: {
    fontSize: 16,
  },
};

function VideoCard(props) {
  const { classes } = props;
  return (
    <Grid container spacing={10}>
      <Grid item xs={12}>
        <Paper className={classes.cardstyle}>
          <Player>
            <source src="https://wiki.instar.com/videos/INSTAR_IP_Kameras_mit_Amazon_Alexa_Skill_nutzen_Monocle.mp4" />
          </Player>
          <div className={classes.figcaption}>
            <p>In diesem Video zeigen wir Ihnen wie Sie mit der Plattform Monocle ganz einfach eine INSTAR IP Kamera so einbinden können, das diese über Amazon Alexa das Videobild abrufen kann. Lassen Sie sich so mit Sprachbefehlen das aktuelle Videobild auf Ihrem Alexa Echo Spot oder Show anzeigen. Auf <OutboundLink href="https://www.youtube.com/watch?v=xFh7eChXVKU" target="_blank" rel="noopener noreferrer">Youtube ansehen <ExternalLink className={classes.icon} /></OutboundLink></p>
          </div>
        </Paper>
      </Grid>
    </Grid>
  );
}

VideoCard.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(VideoCard)